"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEditing = isEditing;
exports.cancelEdit = cancelEdit;
exports.changeEdit = changeEdit;
exports.submitEdit = submitEdit;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var selectionUtils = _interopRequireWildcard(require("./selectionUtils"));

function isEditing(editing) {
  return !(0, _isNil.default)(editing.value);
}

function cancelEdit() {
  return {
    value: null
  };
}

function changeEdit(value) {
  return {
    value: value
  };
}

function submitEdit(columns, rows, selection, editing) {
  if (selectionUtils.isEmpty(selection) || !isEditing(editing)) {
    return rows;
  }

  var value = editing.value;
  var activeX = selection.activeX,
      activeY = selection.activeY;
  var column = columns[activeX];
  var row = rows[activeY];
  var newRow = (0, _objectSpread3.default)({}, row, (0, _defineProperty2.default)({}, column, value));
  var newRows = rows.slice();
  newRows.splice(activeY, 1, newRow);
  return newRows;
}